/**
 * Discount Kit -> theme cart bridge
 *
 * The Discount Kit app embed (app block `discount-kit/blocks/core`) auto-adds and removes
 * GWP items on its own, outside of assets/component-product-form.js and assets/cart.js. With
 * its `refresh_on_cart_change` setting on it used to call window.location.reload() after each
 * gift change (dk_core.js), which closed the cart drawer and reset the page. That setting is
 * now off, so nothing repaints the cart unless the theme is told about the change.
 *
 * Discount Kit only signals when gifts were actually added or removed (its `hasNetChange`
 * branch), and then fires, back to back:
 *
 *   - 'discount_kit:refresh_cart'   always
 *   - the configured custom cart update event, defaulting to 'discount_kit:cart_changed'
 *
 * Both are relayed as a single 'ajaxProduct:added', the event the theme already uses for
 * "the cart changed, re-read it": cart-items re-renders the drawer/cart sections,
 * cart-recommendations reloads, cart-checkout-bar re-syncs and shipping-progress re-fetches
 * /cart.js. That event carries no payload by design, so every listener re-reads the cart and
 * sees the gift line.
 *
 * The relay is collapsed to one dispatch per tick so the pair above cannot trigger two cart
 * section fetches, and the theme never writes to the cart here — no feedback loop with the
 * app's own cart observer.
 */
(function () {
  var scheduled = false;

  function relay() {
    if (scheduled) return;
    scheduled = true;

    setTimeout(function () {
      scheduled = false;
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    }, 0);
  }

  var config = (window.discount_kit && window.discount_kit.config) || {};
  var events = ['discount_kit:refresh_cart', 'discount_kit:cart_changed'];

  if (config.custom_cart_update_event && events.indexOf(config.custom_cart_update_event) === -1) {
    events.push(config.custom_cart_update_event);
  }

  events.forEach(function (name) {
    document.addEventListener(name, relay);
  });
})();
